export const isFileUploaded = ({fileList, fileTypeID}) => {
  if (!fileList) return false;

  const file = fileList.find(file => file?.shumaID && file?.fileTypeID === fileTypeID);

  if (!file) return false;

  const fileTypes = [
    1, 3, 4, 5, 6, 7, 26, 27, 28, 29, 30, // step-1
    10, 11, 33, // step-3
    2, 8, //step-4
    12, 13, 14, 15, 16, 22, 23, 24, 25, 32, // step-6
    36, // step-8
    34, 35, //step-12
  ];

  return fileTypes.includes(file.fileTypeID)
    ? Boolean(file.fileName)
    : Boolean(file.fileExists);
};

